/* Woolina stok duzeltmeleri (20 Tem 2026)
   1) +/- butonlari stok 1'de de gorunur kalir (plus pasiflesir)
   2) Varyant degisiminde adet siniri (max) dogru uygulanir, deger kelepcelenir
   3) Stok <= 4 ise dinamik "Nog maar X op voorraad!" bildirimi (buton satirinin ALTINDA) */
(function () {
  'use strict';
  var THRESHOLD = 4;

  function getInput(c) {
    return c ? c.querySelector('input[name="quantity"]') : null;
  }

  function fixQuantityUI(c) {
    var input = getInput(c);
    if (!input) return;
    c.querySelectorAll('button.quantity__button').forEach(function (b) { b.style.display = ''; });
    var max = parseInt(input.max, 10);
    if (max >= 1 && parseInt(input.value, 10) > max) {
      input.value = max;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (typeof c.validateQtyRules === 'function') c.validateQtyRules();
  }

  function renderLowStock(c, suppress) {
    var input = getInput(c);
    if (!input) return;
    var max = parseInt(input.max, 10);
    /* Bildirimi flex satirinin DISINA koy: buton sikismasin */
    var row = c.closest('.product-form__buttons__content') || c;
    var host = row.parentElement || document.body;
    var note = host.querySelector('.woolina-lowstock');
    var show = !suppress && max >= 1 && max <= THRESHOLD;
    if (show) {
      if (!note) {
        note = document.createElement('div');
        note.className = 'woolina-lowstock';
        note.style.cssText = 'width:100%;margin-top:0.8rem;font-size:1.4rem;font-weight:600;color:#c0392b;';
        row.insertAdjacentElement('afterend', note);
      }
      note.textContent = 'Nog maar ' + max + ' op voorraad!';
      note.style.display = '';
    } else if (note) {
      note.style.display = 'none';
    }
  }

  function apply(c, suppress) {
    if (!c) return;
    fixQuantityUI(c);
    renderLowStock(c, suppress);
  }

  function boot() {
    var containers = document.querySelectorAll('[id^="Quantity-container-"]');
    var hasPicker = !!document.querySelector('variant-selects');
    var variantInUrl = /[?&]variant=/.test(location.search);
    containers.forEach(function (c) { apply(c, hasPicker && !variantInUrl); });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var sid = evt && evt.data && evt.data.sectionId;
        var c = sid ? document.getElementById('Quantity-container-' + sid) : document.querySelector('[id^="Quantity-container-"]');
        apply(c, false);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
